/* eslint-disable no-undef */
export default {
	name: "order-items-table",
	props: ["orderId", "orderTotal", "orderTypeId"],
	//emits: ["shippingAddressSelected"],
	data() {
		return {
			orderItems: [],
			grandTotal: 0,
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product", //TODO: add product name
                    id: "productColumn"
				},
                {
                    text: "Product Type",
                    field: "productType",
                    id: "productTypeColumn"
                },
				{
					text: "Price",
					field: "priceAsString",
                    id: "priceColumn"
				},
				{
					text: "Quantity/Litres",
					field: "quantity",
                    id: "quantityColumn"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed",
                    id: "amountDispensedColumn"
				},
				{
					text: "Total",
					field: "totalAsString",
                    id: "totalsColumn"
				},
				{
					text: "Discounted Amount",
					field: "totalDiscountAmountAsString",
                    id: "discountAmountColumn"
				},
				{
					text: "Price After Discount",
					field: "priceAfterDiscountAsString",
                    id: "priceAfterDiscountColumn"
				},
				{
					text: "Total Price Dispensed",
					field: "totalAmountDispensedAsString",
                    id: "totalPriceDispensedColumn"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			useFourDecimalPlaces: false,
		};
	},
	methods: {
		getOrderItems() {
            this.loading = true;
            this.orderItemsHeadings = permissionsHelper.setTableColumnsBasedOnPermissions(this.orderItemsHeadings);
            permissionsHelper.setControlsBasedOnPermissions();
			orderService.getOrderItemsForOrder(this.orderId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orderItems = successResponse.data.result;
						this.orderItems = dataTableHelper.castObjectValues(this.orderItems);
						for(var i = 0; i < this.orderItems.length; i++){
							this.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.orderItems[i].unitPrice);
							this.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalAmount);
							this.orderItems[i].totalAmountDispensedAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalAmountDispensed);
							this.orderItems[i].discountedAmountAsString = "";
							this.orderItems[i].priceAfterDiscount = 0;
							this.orderItems[i].priceAfterDiscountAsString = "";
							this.orderItems[i].totalDiscountAmount = 0;
							this.orderItems[i].totalDiscountAmountAsString = "";
							if(this.orderItems[i].discountedAmount !== null && this.orderItems[i].discountedAmount > 0){
								this.orderItems[i].totalDiscountAmount = this.orderItems[i].quantity * this.orderItems[i].discountedAmount;
								this.orderItems[i].totalDiscountAmountAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalDiscountAmount);
								this.orderItems[i].discountedAmountAsString = currencyHelper.numberToCurrency(this.orderItems[i].discountedAmount);
								this.orderItems[i].priceAfterDiscount = this.orderItems[i].totalAmount - this.orderItems[i].totalDiscountAmount;
								this.orderItems[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.orderItems[i].priceAfterDiscount);
							}
							if(this.useFourDecimalPlaces){
								this.orderItems[i].priceAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].unitPrice);
								this.orderItems[i].totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].totalAmount);
								this.orderItems[i].totalAmountDispensedAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].totalAmountDispensed);
								this.orderItems[i].totalDiscountAmountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].totalDiscountAmount);
								this.orderItems[i].discountedAmountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].discountedAmount);
								this.orderItems[i].priceAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].priceAfterDiscount);
							}
						}
                        permissionsHelper.setControlsBasedOnPermissions();
                        this.loading = false;
						console.log("orderItems", this.orderItems);
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
                    this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
        
	},
	watch:{
		orderId:{
			handler: function () {
				console.log("orderId", this.orderId);
				if(this.orderId !== null && this.orderId > 0){
					this.getOrderItems();
				}
			},
			immediate: true,
			deep: true
		},
		orderTotal:{
			handler: function () {
				console.log("orderTotal", this.orderTotal);
				if(this.orderTotal !== null){
					this.grandTotal = this.orderTotal;
				}
			},
			immediate: true,
			deep: true
		},
		orderTypeId: {
			handler : function () {
				if(this.orderTypeId !== null && this.orderTypeId > 0){
					if(this.orderTypeId === orderHelper.orderType.exTank){
						this.useFourDecimalPlaces = true;
					}
				}
			},
			immediate: true,
			deep: true
		}
	}
};
